import { useContext, useEffect, useState } from "react";
import MainLayout from "../Container/Layout/MainLayout";
// context
import { Context } from "../Context/Context";
// style
import styles from "../Styles/Ticket.module.css"
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { getNotification } from "../Services/ContectService";
import moment from "jalali-moment";
import swal from "sweetalert";

const Notification = () => {
    const { json, user, setLoading } = useContext(Context);
    const content = json?.Ticket;
    const [listNotification, setListNotification] = useState([]);

    const notificationHandeler = async () => {
        setLoading(true);
        try {
            const { status, data } = await getNotification(user);
            if (status === 200) {
                setListNotification(data);
                setLoading(false);
            }
        } catch (error) {
            toast.error(json.toast.err_1);
            setLoading(false);
        }
    }

    const swalNotificationHandeler = async (item) => {
        swal({
            title: item.subject,
            text: item.context[0].context,
            buttons: {
                cancel: "متوجه شدم"
            },
            dangerMode: true,
        })
    }

    useEffect(() => {
        notificationHandeler();
    }, [])

    return (
        <MainLayout>
            <div className={styles.account_frame}>
                <div className={styles.account_frame_header}>
                    <h2 className="bold w-100 text-h4">{content.title_2}</h2>
                </div>
                <div className={styles.table}>
                    {listNotification.length > 0 ?
                        <table className="account-table">
                            <thead>
                                <tr>
                                    <th>
                                        #
                                    </th>
                                    <th>
                                        {content.issue}
                                    </th>
                                    <th>
                                        {content.postagedate}
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>

                                {listNotification.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            {index + 1}
                                        </td>
                                        <td>
                                            {item.subject}
                                        </td>
                                        <td>
                                            {moment(item.create_at, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}
                                        </td>
                                        <td className="d-flex flex-nowrap gap-2">
                                            <button onClick={() => swalNotificationHandeler(item)} className="main-btn bg-primary color-white">
                                                {content.button_table1}
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                        : <p>{json.notfound}</p>
                    }

                </div>

            </div>
        </MainLayout>
    );
}

export default Notification;